import type { RootState } from 'state';
import type { FlightsCalendarsFiltersOptionsState } from '../slice';

function getAirportsTo(state: RootState): FlightsCalendarsFiltersOptionsState['airportsTo'] {
  const { airportsTo } = state.flightCalendars.filtersOptions;
  return airportsTo;
}

export default getAirportsTo;
